import { useEffect, useRef } from "react";
/**
 * Clears dependent form fields when a watched field changes after mount.
 *
 * Form dialogs commonly prefill values when opened (so the initial state
 * looks like a "change"). This hook tracks the previous value via a ref so
 * dependent fields are only cleared on a *real* user change, not the
 * initial mount or a reset.
 */ export function useClearOnChange({ form, watch, clearFields, shouldClear, initial, isOpen }) {
    const previousRef = useRef(undefined);
    const current = form.watch(watch);
    const { setValue } = form;
    useEffect(function captureInitialValueOnOpen() {
        if (isOpen) previousRef.current = initial;
    }, [
        isOpen,
        initial
    ]);
    useEffect(function clearDependentFieldsOnChange() {
        const prev = previousRef.current;
        if (prev !== undefined && current !== prev && (!shouldClear || shouldClear(current))) {
            for (const field of Object.keys(clearFields)){
                const clearedValue = clearFields[field];
                // Optional map keys admit an explicit `undefined` the cast below
                // would otherwise launder into setValue — treat it as "not listed".
                if (clearedValue === undefined) continue;
                setValue(field, clearedValue, {
                    shouldDirty: true
                });
            }
        }
        previousRef.current = current;
    }, [
        current,
        clearFields,
        shouldClear,
        setValue
    ]);
}

//# sourceMappingURL=useClearOnChange.js.map